/* eslint-disable */
bz_app.factory('zoomService', [
  '$rootScope',
  'propertiesService',
  function ($rootScope, propertiesService) {
    var MAX_ZOOM_IN_LEVEL = (MICRO_NEIGHBORHOOD_ZOOM_LEVEL = 19)
    var MAX_ZOOM_OUT_LEVEL = (NATIONAL_ZOOM_LEVEL = isMobile.check() ? 3 : 4)
    var SUPPORTED_ZOOM_LEVELS = [
      NATIONAL_ZOOM_LEVEL,
      10,
      12,
      14,
      16,
      18,
      MAX_ZOOM_IN_LEVEL,
    ]
    var BAY_AREA_LAT = 37.7833,
      BAY_AREA_LNG = -122.4167
    var zoomService = {
      zoomInDisabled: false,
      zoomOutDisabled: false,
      currentGoogleLevel: '',
      map: '',
      registerEventListeners: function () {
        $rootScope.$on('mapInitialized', function (event, map) {
          zoomService.currentGoogleLevel = map.zoom
          zoomService.map = map
          zoomService.updateButtonDisabledStatus()
        })
      },
      updateButtonDisabledStatus: function () {
        if (zoomService.currentGoogleLevel == MAX_ZOOM_IN_LEVEL) {
          zoomService.zoomInDisabled = true
        } else {
          zoomService.zoomInDisabled = false
        }
        if (zoomService.currentGoogleLevel == MAX_ZOOM_OUT_LEVEL) {
          zoomService.zoomOutDisabled = true
        } else {
          zoomService.zoomOutDisabled = false
        }
      },
      changeZoom: function (newZoomLevel) {
        var newZoomLevel = parseInt(newZoomLevel)
        if (
          typeof newZoomLevel != 'undefined' &&
          SUPPORTED_ZOOM_LEVELS.indexOf(newZoomLevel) > -1
        ) {
          if (zoomService.currentGoogleLevel != newZoomLevel) {
            zoomService.map.setZoom(newZoomLevel)
            zoomService.currentGoogleLevel = newZoomLevel
            zoomService.updateButtonDisabledStatus()
          }
          if (zoomService.currentGoogleLevel != NATIONAL_ZOOM_LEVEL) {
            propertiesService.setParam('zoom', zoomService.currentGoogleLevel)
          }
        }
      },
      clickZoom: function (newZoomLevel) {
        zoomService.changeZoom(newZoomLevel)
        $rootScope.$broadcast(
          'zoom.clicked',
          newZoomLevel == NATIONAL_ZOOM_LEVEL
        )
      },
      zoomIn: function () {
        if (zoomService.currentGoogleLevel != MAX_ZOOM_IN_LEVEL) {
          var index = SUPPORTED_ZOOM_LEVELS.indexOf(
            zoomService.currentGoogleLevel
          )
          if (SUPPORTED_ZOOM_LEVELS[index] == NATIONAL_ZOOM_LEVEL) {
            zoomService.defaultZoomFromNational()
          }
          zoomService.clickZoom(SUPPORTED_ZOOM_LEVELS[++index])
        }
      },
      zoomOut: function () {
        if (zoomService.currentGoogleLevel != MAX_ZOOM_OUT_LEVEL) {
          var index = SUPPORTED_ZOOM_LEVELS.indexOf(
            zoomService.currentGoogleLevel
          )
          if (SUPPORTED_ZOOM_LEVELS[index - 1] == NATIONAL_ZOOM_LEVEL) {
            zoomService.setNationalZoom()
            $rootScope.in_progress = true
          } else {
            propertiesService.resetParam('sort')
            zoomService.clickZoom(SUPPORTED_ZOOM_LEVELS[--index])
          }
        }
      },
      setNationalZoom: function () {
        propertiesService.resetParam('zoom')
        zoomService.clickZoom(NATIONAL_ZOOM_LEVEL)
      },
      setMicroNeighborhoodZoom: function () {
        zoomService.changeZoom(MICRO_NEIGHBORHOOD_ZOOM_LEVEL)
      },
      // clicking zoomIn from national view defaults to Bay Area metro area view
      defaultZoomFromNational: function () {
        $rootScope.$broadcast('permit_map.center', BAY_AREA_LAT, BAY_AREA_LNG)
        replaceURL('-wide', 'san-francisco-ca')
      },
      isMaxZoomLevel: function () {
        return zoomService.currentGoogleLevel == MAX_ZOOM_IN_LEVEL
      },
    }
    return zoomService
  },
])
